import { useMutation } from 'libs/query'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useToast } from 'shared/hooks'

import type { ResetPasswordReqBody } from '../PasswordReset'

export const useResetPasswordMutation = () => {
	const { t } = useTranslation()

	const {
		mutate: resetPasswordMutation,
		isPending: isResetPasswordLoading,
		isSuccess: isResetPasswordSuccess
	} = useMutation({
		mutationFn: ({ email }: ResetPasswordReqBody) =>
			// change to apiRoute
			axios.post('/accounts/request-password-reset/', { email }),
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		}
	})

	return {
		resetPasswordMutation,
		isResetPasswordLoading,
		isResetPasswordSuccess
	}
}
